import i18next from 'i18next'
import * as React from 'react'
import { Link } from '../../../../utils/links'
import { InviewProps } from '../blocksState'
import { LinkGridBlockLayout } from '../linkGridBlockLayout'
import { AllCourseGroups } from './allCourseGroupsBlockState'

export type AllCourseGroupsBlockProps = {
  index: number
  inview?: InviewProps
  title?: React.ReactNode
  children: AllCourseGroups
  query?: string
  setQuery: (query: string) => void
}

export function AllCourseGroupsBlockLayout(props: AllCourseGroupsBlockProps) {
  return props.children.length > 0 ? (
    <>
      <section className="block block--search">
        <div className="block__inner container--s spacing--m gutter--m">
          <header className="block__header">
            <h2 className="block__title title--m">
              {i18next.t('search:titleCourses')}
            </h2>
          </header>

          <div className="block__content">
            <div className="blockform blockform--search">
              <div className="blockform__inner">
                <label className="sr-text" htmlFor="a11y-c-search">
                  {i18next.t('search:placeholderCourses')}
                </label>
                <form>
                  <input
                    className="blockform__input"
                    id="a11y-c-search"
                    name="c-search"
                    type="search"
                    value={props.query}
                    onChange={e => props.setQuery(e.target.value)}
                    placeholder={i18next.t('search:placeholderCourses')}
                  />
                  <Link url={`/opleidingen/zoeken?page=1&search=${props.query}`}>
                    <button
                      type="submit"
                      className="blockform__button button button--primary button--icon"
                    >
                      <span className="button__label">
                        {i18next.t('search:search')}
                      </span>
                      <svg className="button__icon" width="18px" height="18px">
                        <use xlinkHref="#icon--search" />
                      </svg>
                    </button>
                  </Link>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <LinkGridBlockLayout
        index={props.index}
        title={props.title}
        inview={props.inview}
        withImages={false}
        items={props.children.map(x => ({
          title: x.HeaderTitle,
          intro: x.HeaderDescription,
          link: {
            url: x.AbsolutePath,
            title: x.HeaderTitle
          }
        }))}
      />
    </>
  ) : null
}
